import { render, staticRenderFns } from "./HistoricoMapa.vue?vue&type=template&id=5620f8d8&scoped=true&"
import script from "./HistoricoMapa.vue?vue&type=script&lang=js&"
export * from "./HistoricoMapa.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoMapa.vue?vue&type=style&index=0&id=5620f8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620f8d8",
  null
  
)

export default component.exports